module.exports = __webpack_public_path__ + "static/media/30-3.20bb0414.mp3";